import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.core').component('countrySelectTag', {
        bindings: {
            model: '=',
            disabled: '<',
            required: '<'
        },
        controller: CountrySelectTag,
        templateUrl: require('./country-select-tag.html')
    });

    CountrySelectTag.$inject = ['CountrySvc', '$scope'];

    function CountrySelectTag(CountrySvc, $scope) {
        var ctrl = this;

        /**
         * Initialisation du composant.
         */
        ctrl.$onInit = function () {
            loadCountries();

        };
        /**
         * Chargement de la liste des pays.
         */
        function loadCountries() {
            return CountrySvc.getAll().then(function (data) {
                ctrl.countries = data;
                return data;
            });
        }

        $scope.loadTags = function (query) {
            const promise = new Promise(((resolve) => {
                resolve(ctrl.countries.filter(function (country) {
                    return country.labelWithCode.toLowerCase().indexOf(query.toLowerCase()) !== -1;
                }))
            }))
            return promise
        };


    }
})();
